import { renderDrawerHeaderTitle_unstable } from '@fluentui/react-drawer';

/**
 * Renders the final JSX of the DrawerHeaderTitle component, given the state.
 */
export const renderDrawerHeaderTitle = renderDrawerHeaderTitle_unstable;
